const { createApp, ref, component, watch, onMounted, reactive, onBeforeMount, Transition, computed } = Vue;

const vipDealsApp = createApp({
	name: "vipDealsApp",
	setup() {
		const activeDeal = ref(null);
		const activeDeals = ref(null);
		const selectedVariant = ref(null);
		const isLoading = ref(false);
		const isTimesUp = ref(false);
		const isSoldOut = ref(false);
		const isAccordianOpen = ref(false);
		let splideSliderEl = null;
		const minQty = ref(1);
		const maxQty = ref(0);
		const selectedQty = ref(minQty.value);
		const showValidationMsg = ref(false);

		onBeforeMount(() => {
			const filteredDeals = getAnActiveDeal(vipDealsObj.deals);
			if (filteredDeals.length === 1) activeDeal.value = filteredDeals[0];
			activeDeals.value = filteredDeals;
			if(activeDeal.value?.product_type === "VARIANT"){
				selectedVariant.value = activeDeal.value.product_variant;
			}
		});

		onMounted(() => {
			splideSliderEl = document.getElementById("x-product-vip");
		});

		function handleVariantChange(e) {
			selectedVariant.value = e;
			isSoldOut.value = !selectedVariant.value.available;
			if (selectedVariant.value.featured_media && selectedVariant.value.featured_media.id) {
				splideSliderEl = splideSliderEl || document.getElementById("x-product-vip");
				const splideThumbnailEl = document.getElementById("x-product-thumbnail-vip");
				if (splideSliderEl && splideThumbnailEl) {
					setTimeout(() => {
						if (splideThumbnailEl) {
							const targetDiv = splideThumbnailEl.querySelector('div[data-media-id="' + selectedVariant.value.featured_media.id+ '"]');
							if (targetDiv) {
								const button = targetDiv.querySelector("button");
								if (button) {
									button.click();
								}
							} 
						}
					}, 500);
				}
			}
		}

		

		async function handleAddToCart() {
			showValidationMsg.value = false;
			try {
				if (!isTimesUp.value && !isSoldOut.value) {
					isLoading.value = true;
					let properties = {};
					if (parseFloat(activeDeal.value.discount_value) > 0) {
						properties = {
							__promo_source: getLastSegment(location.pathname),
							__deal_expiration: numToAlpha(activeDeal.value.sale_period_end),
							__max_order_qty: activeDeal.value.max_order_quantity,
						};
					}
					let productPayload = {
						quantity: selectedQty.value,
						id: selectedVariant.value.id,
						properties,
					};
					await fetch(window.Shopify.routes.root + "cart/add.js", {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
						},
						body: JSON.stringify({ items: [productPayload] }),
					}).then((resp) => resp.json());
				}
			} catch (error) {
				console.log(error);
			} finally {
				isLoading.value = false;
			}
		}

	function handleOnTimeEnd(e) {
		// console.log('handleOnTimeEnd', e);
		isTimesUp.value = e;
	}

		function toggleAccordion() {
			isAccordianOpen.value = !isAccordianOpen.value;
		}

		function handleQtyChange(type) {
			if (type === "+") {
				if (selectedQty.value == maxQty.value) {
					showValidationMsg.value = true;
				} else {
					selectedQty.value = selectedQty.value + 1;
				}
			} else {
				selectedQty.value = selectedQty.value - 1;
				showValidationMsg.value = false;
			}
		}

		function handleProductChange(selectedDeal) {
			activeDeal.value = selectedDeal.deal;
			if(selectedDeal.variant){
			  	handleVariantChange(selectedDeal.variant);
			}
			setActiveDeal();
			window.scrollTo(0, 0);
		}

		function setActiveDeal() {
			if (activeDeal.value !== null) {
                maxQty.value = activeDeal.value.max_order_quantity;
                isAccordianOpen.value = !activeDeal.value.collapse_description;
				if (activeDeal.value.product_type === "PRODUCT" && typeof activeDeal.value.product != "object") {
					throw new Error(`No product set for the deal product_type: ${activeDeal.value.product}`);
				}

				if (activeDeal.value.product_type === "VARIANT" && typeof activeDeal.value.product_variant != "object") {
					throw new Error(`No product variant set for the deal product_type: ${activeDeal.value.product}`);
				}

				if (activeDeal.value.product_type === "VARIANT") {
					selectedVariant.value = activeDeal.value.product_variant;
				}

				if (selectedVariant.value) {
					isSoldOut.value = !selectedVariant.value.available;
				}
			}
		}

		function handleBackBtnClick() {
			activeDeal.value = null;
			window.okeWidgetApi.initAllWidgets();
		}

		return {
			activeDeal,
			selectedVariant,
			isLoading,
			isTimesUp,
			isSoldOut,
			isAccordianOpen,
			selectedQty,
			maxQty,
			minQty,
			showValidationMsg,
			activeDeals,
			vipDealsObj,
			splideSliderEl,
			formatMoneyy,
			calculateDiscountedPrice,
			convertToEST,
			handleVariantChange,
			handleAddToCart,
			handleOnTimeEnd,
			toggleAccordion,
			imgUrl,
			handleQtyChange,
			handleProductChange,
			setActiveDeal,
			handleBackBtnClick
		};
	},
	delimiters: ["${", "}"],
});

// carousel
vipDealsApp.component("product-carousel", {
	template: "#productCarousel",
	emits: [],
	props: ["media", "product_details"],
	setup(props, ctx) {
		const mediaItems = reactive(props.media);
		const productDetails = reactive(props.product_details);
		return {
			mediaItems,
			productDetails,
			imgUrl,
			imgSrcSet,
		};
	},
	delimiters: ["${", "}"],
});

// count down
vipDealsApp.component("deal-countdown", {
	template: "#countDown",
	emits: [],
	props: ["end_time"],
	setup(props, ctx) {
		const remainingTime = ref(props.end_time - convertToEST(new Date()));
		const hours = ref(0);
		const minutes = ref(0);
		const seconds = ref(0);

		const updateCountdown = () => {
			if (remainingTime.value > 0) {
				let timeDiff = remainingTime.value / 1000;
				const hoursValue = Math.floor(timeDiff / 3600);
				timeDiff %= 3600;
				const minutesValue = Math.floor(timeDiff / 60);
				const secondsValue = Math.floor(timeDiff % 60);
				hours.value = hoursValue;
				minutes.value = minutesValue;
				seconds.value = secondsValue;
				remainingTime.value -= 1000;
			} else {
				clearInterval(updateCounterInterval);
				ctx.emit("on_time_end", true);
			}
		};

		// Update countdown every second
		const updateCounterInterval = setInterval(updateCountdown, 1000);

		return {
			hours,
			minutes,
			seconds,
			convertToEST,
		};
	},
	delimiters: ["${", "}"],
});

// banner count down
vipDealsApp.component("deal-countdown-banner", {
	template: "#countDownBanner",
	emits: [],
	props: ["end_time"],
	setup(props, ctx) {
		const remainingTime = ref(props.end_time - convertToEST(new Date()));
		const days = ref(0);
		const hours = ref(0);
		const minutes = ref(0);
		const seconds = ref(0);

		const updateCountdown = () => {
			if (remainingTime.value > 0) {
				let timeDiff = remainingTime.value / 1000;
				const daysValue = Math.floor(timeDiff / (3600 * 24));
				timeDiff %= 3600 * 24;
				const hoursValue = Math.floor(timeDiff / 3600);
				timeDiff %= 3600;
				const minutesValue = Math.floor(timeDiff / 60);
				const secondsValue = Math.floor(timeDiff % 60);
				days.value = daysValue;
				hours.value = hoursValue;
				minutes.value = minutesValue;
				seconds.value = secondsValue;
				remainingTime.value -= 1000;
			} else {
				clearInterval(updateCounterInterval);
				ctx.emit("on_time_end", true);
			}
		};

		// Update countdown every second
		const updateCounterInterval = setInterval(updateCountdown, 1000);

		return {
			days,
			hours,
			minutes,
			seconds,
			convertToEST,
		};
	},
	delimiters: ["${", "}"],
});

// variant selector
vipDealsApp.component("product-variant-select", {
	template: "#variantSelect",
	emits: ["on_variant_change"],
	props: ["product","selected_variant"],
	setup(props, ctx) {
		const selectedVariant = ref(null);
		const variantContEl = ref(null);

		onBeforeMount(() => {
			if(props.selected_variant){
				selectedVariant.value = props.selected_variant;
			}else{
				selectedVariant.value = props.product?.variants.find((v) => v?.available);
			}
		});

		onMounted(() => {
			if (selectedVariant.value) {
				if (props.product.variants?.length > 1) {
					handleVariantChecked();
					hideUnRelatedVariants();
				}
				ctx.emit("on_variant_change", selectedVariant.value);
			}
		});

		function handleVariantChecked() {
			if (variantContEl.value) {
				selectedVariant.value.options.forEach((option_value) => {
					variantContEl.value.querySelectorAll(`input[type='radio'][value='${option_value}']`).forEach((el) => {
						el.checked = true;
					});
				});
			}
		}

		function hideUnRelatedVariants() {
			const optionWithValues = props.product?.options_with_values;
			const activeOptions = [...selectedVariant.value.options];
			const productVariants = props.product.variants;
			const swatchGroups = variantContEl.value.querySelectorAll(".variant-block__swatch");
			variantContEl.value
				.querySelectorAll(`input[type='radio']`)
				.forEach((el) => el.parentElement.classList.remove("hide-option"));
			swatchGroups.forEach((grpEl, i) => {
				let groupPosition = parseInt(grpEl.getAttribute("data-option-position"));
				if (optionWithValues.length > 1 && groupPosition > 1 && groupPosition <= optionWithValues.length) {
					const primaryOptions = activeOptions.slice(0, i);
					let groupInputs = grpEl.querySelectorAll('input[type="radio"]');
					if (groupInputs) {
						groupInputs.forEach((el) => {
							let isPartOfAnyVariant = false;
							for (let variant of productVariants) {
								const optionCombination = [...primaryOptions, el.value];
								const isUnRelatedVariant = optionCombination.every((o) => variant.options.includes(o));
								if (isUnRelatedVariant) {
									isPartOfAnyVariant = true;
									break;
								}
							}
							if (!isPartOfAnyVariant) {
								el.parentElement.classList.add("hide-option");
							}
						});
					}
				}
			});
		}

		function handleDisableVariant(option_name) {
			return selectedVariant.value.options.includes(option_name);
		}

		function handleVariantSelect(e) {
			const selectedOptionArr = [];
			const selectedVariantInputRadio = variantContEl.value.querySelectorAll("input[type='radio']:checked");
			const productVariants = props.product.variants;
			let matchedVariant = null;
			selectedVariantInputRadio.forEach((el) => {
				selectedOptionArr.push(el.value);
			});
			if (selectedOptionArr.length) {
				for (let variant of productVariants) {
					const isSelectedVariant = selectedOptionArr.every((o) => variant.options.includes(o));
					if (isSelectedVariant) {
						matchedVariant = variant;
						break;
					}
				}
				if (matchedVariant) {
					selectedVariant.value = matchedVariant;
				} else {
					let partialCombination = [e.target.value];
					if (selectedOptionArr.length > 2) {
						const optionsLength = props.product?.options_with_values.length;
						partialCombination = selectedOptionArr.slice(0, optionsLength - 1);
					}
					for (let variant of productVariants) {
						const isSelectedVariant = partialCombination.every((o) => variant.options.includes(o));
						if (isSelectedVariant) {
							matchedVariant = variant;
							break;
						}
					}
					if (!matchedVariant) {
						matchedVariant = productVariants.find((variant) => variant.options.includes(e.target.value));
					}
				}
			}
			selectedVariant.value = matchedVariant;
			handleVariantChecked();
			hideUnRelatedVariants();
			ctx.emit("on_variant_change", selectedVariant.value);
		}

		return {
			selectedVariant,
			variantContEl,
			handleVariantChecked,
			handleVariantSelect,
			handleize,
			handleDisableVariant,
		};
	},
	delimiters: ["${", "}"],
});

// product grid
vipDealsApp.component("product-grid", {
	template: "#productGrid",
	emits: ["on_deal_change"],
	props: ["deals", "pagination_limit"],
	setup(props, ctx) {
		const currentLimit = ref(props.pagination_limit)
		const allProductVariants = computed(() => {
			return props.deals.flatMap(d => {
				if (d.product_type === "VARIANT") {
					return [{
						...d.product_variant,
						discount_type: d.discount_type,
						discount_value: d.discount_value,
						deal: d
					}];
				}
				if (d.product_type === "PRODUCT") {
					return d.product.variants.map(variant => ({
						...variant,
						discount_type: d.discount_type,
						discount_value: d.discount_value,
						main_product: d.product,
						deal: d
					}));
				}
				return [];
			});
		});

		const visibleVariants = computed(() =>
			allProductVariants.value.slice(0, currentLimit.value)
		);

		const showLoadMore = computed(() =>
			currentLimit.value < allProductVariants.value.length
		)

		function loadMore() {
			const remaining = allProductVariants.value.length - currentLimit.value;
			currentLimit.value += Math.min(props.pagination_limit, remaining);
			window.okeWidgetApi.initAllWidgets();
		}

		function handleProductClick(deal, variant = null) {
			ctx.emit("on_deal_change", variant ? { deal, variant } : { deal });
			window.okeWidgetApi.initAllWidgets();
		}

		return {
			allProductVariants,
			showLoadMore,
			visibleVariants,
			handleProductClick,
			calculateDiscountedPrice,
			formatMoneyy,
			loadMore,
		};
	},

	delimiters: ["${", "}"],
});


vipDealsApp.mount("#vipDealsApp");

function getAnActiveDeal(deals = []) {
	const currentDateTime = convertToEST(new Date());
	let activeDeals = [];
	for (let deal of deals) {
		let saleStart = convertToEST(deal.sale_period_start);
		let saleEnd = convertToEST(deal.sale_period_end);
		if (saleStart <= currentDateTime && currentDateTime <= saleEnd) {
			activeDeals.push(deal);
		}
	}
	return activeDeals;
}

function convertToEST(date) {
	let providedDate = new Date(date);
	let options = {
		timeZone: "America/New_York",
	};
	let estTime = providedDate.toLocaleString("en-US", options);
	return new Date(estTime);
}

function formatMoneyy(cents, format = "") {
	if (typeof cents === "string") {
		cents = cents.replace(".", "");
	}
	const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
		formatString = format || window.themeVariables.settings.moneyFormat;
	function defaultTo(value2, defaultValue) {
		return value2 == null || value2 !== value2 ? defaultValue : value2;
	}
	function formatWithDelimiterss(number, precision, thousands, decimal) {
		precision = defaultTo(precision, 2);
		thousands = defaultTo(thousands, ",");
		decimal = defaultTo(decimal, ".");
		if (isNaN(number) || number == null) {
			return 0;
		}
		number = roundNumber(number / 100, false, precision);
		let parts = number.split("."),
			dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
			centsAmount = parts[1] ? decimal + parts[1] : "";
		return dollarsAmount + centsAmount;
	}
	let value = "";
	switch (formatString.match(placeholderRegex)[1]) {
		case "amount":
			value = formatWithDelimiterss(cents, 2);
			break;
		case "amount_no_decimals":
			value = formatWithDelimiterss(cents, 0);
			break;
		case "amount_with_space_separator":
			value = formatWithDelimiterss(cents, 2, " ", ".");
			break;
		case "amount_with_comma_separator":
			value = formatWithDelimiterss(cents, 2, ".", ",");
			break;
		case "amount_with_apostrophe_separator":
			value = formatWithDelimiterss(cents, 2, "'", ".");
			break;
		case "amount_no_decimals_with_comma_separator":
			value = formatWithDelimiterss(cents, 0, ".", ",");
			break;
		case "amount_no_decimals_with_space_separator":
			value = formatWithDelimiterss(cents, 0, " ");
			break;
		case "amount_no_decimals_with_apostrophe_separator":
			value = formatWithDelimiterss(cents, 0, "'");
			break;
	}
	if (formatString.indexOf("with_comma_separator") !== -1) {
		return formatString.replace(placeholderRegex, value);
	} else {
		return formatString.replace(placeholderRegex, value);
	}
}

function roundNumber(num, savings, precision = 2) {
	if (isNaN(num)) {
		return;
	}

	let nummm = num.toFixed(3).split(".")[1].slice(2);
	if (nummm > 4 && !savings) {
		let number = Math.ceil((num + Number.EPSILON) * 100) / 100;
		return number.toFixed(precision);
	} else if (nummm < 6 && savings) {
		let number = Math.floor((num + Number.EPSILON) * 100) / 100;
		return number.toFixed(precision);
	} else {
		let number = Math.round((num + Number.EPSILON) * 100) / 100;
		return number.toFixed(precision);
	}
}

function calculateDiscountedPrice(salePrice = 0, discount = 0) {
	if (salePrice < 0 || discount < 0) {
		throw "Sale price and discount must be non-negative values.";
	}

	const discountAmount = (discount / 100) * salePrice;
	const discountedPrice = salePrice - discountAmount;

	return discountedPrice;
}

function handleize(str) {
	return str
		.toLowerCase()
		.replace(/\s+/g, "-")
		.replace(/[^\w\-]+/g, "")
		.replace(/\-\-+/g, "-")
		.replace(/^-+/, "")
		.replace(/-+$/, "");
}

function getLastSegment(url) {
	url = url.replace(/\/+$/, "");
	var segments = url.split("/");
	var lastSegment = segments[segments.length - 1];
	return lastSegment;
}

function imgUrl(url, size) {
	if(!url) url = `https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif`;
	// remove any current image size then add the new image size
	return url
		.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, ".")
		.replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {
			return "_" + size + match;
		});
}

function numToAlpha(date) {
	return date
		.split("-")
		.map((part) =>
			part
				.split("")
				.map((char) => String.fromCharCode(char.charCodeAt(0) - "0".charCodeAt(0) + "A".charCodeAt(0)))
				.join("")
		)
		.join("-");
}

function alphaToNum(alphaDate) {
	return alphaDate
		.split("-")
		.map((part) =>
			part
				.split("")
				.map((char) => String.fromCharCode(char.charCodeAt(0) - "A".charCodeAt(0) + "0".charCodeAt(0)))
				.join("")
		)
		.join("-");
}

function imgSrcSet(url) {
	const sizes = [
		200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800, 2000, 2200, 2400, 2600, 2800, 3000, 3200,
	];
	return sizes.map((size) => `${url}&width=${size} ${size}w`).join(", ");
}